<template>
  <div class="inputwrapper">
    <a class="button_Search" @click="searchWord">
      <i class="icon-lupa"></i>
    </a>
    <input
      v-model="filter"
      @keyup="searchWord"
      id="searchstring"
      :placeholder="placeholder" />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { i18n } from "@/main";

export default {
  name: "Searchbox",
  emits: ["searchWord"],
  props: {
    placeholderText: {
      type: String
    },
  },
  setup(props, { emit }) {

    const { t } = i18n.global; // Use useI18n to access $t as t
    const placeholder = computed(() => {
      return props.placeholderText || t('pesquisarDocs');
    });

    const filter = ref("");

    const searchWord = () => {
      emit("searchWord", filter.value);
    };

    // Return the reactive properties and methods to use in the template
    return {
      filter,
      searchWord,
      placeholder,
    };
  },
};
</script>

<style scoped>
.inputwrapper {
  border: 1px solid #79b2dc;
  display: flex;
  padding: 6px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 250px;
  height: 45px;
  text-align: center;
  color: #777575;
  align-items: center;
}

.button_Search {
  font-size: 22px;
  padding-right: 5px;
}

#searchstring {
  font-family: "Montserrat";
  color: #cacaca;
  font-size: 15px;
  border: 0;
  background: transparent;
  width: 300px;
}

@media (max-width: 767px) {
  .inputwrapper {
    width: 100%;
    height: 45px;
  }

  .button_Search {
    font-size: 20px;
    padding-top: 2px;
  }

  #searchstring {
    font-size: 14px;
  }

}

[class^="icon-"]:before, [class*=" icon-"]:before {
  font-family: "siteuma";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: .2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: .2em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-lupa:before { 
  font-family: "siteuma"; 
  content: '\e800'; 
} 

input:focus-visible{
  outline: none;
}
</style>
